import { utcToZonedTime } from 'date-fns-tz'

export function formatearFechaHora(value: any) {
  if (!value) return "";
  
  const selectedTimezone = useState<string>(
    'selected-timezone',
    () => 'America/Guayaquil'
  )

  // Si no tiene offset ni Z, asumir que es UTC
  const normalized = value.includes('Z') || value.includes('+') 
    ? value 
    : value + 'Z';

  const date = new Date(normalized);
  const zonedDate = utcToZonedTime(date, selectedTimezone.value);

  const year = zonedDate.getFullYear();
  const month = String(zonedDate.getMonth() + 1).padStart(2, "0");
  const day = String(zonedDate.getDate()).padStart(2, "0");
  const hours = String(zonedDate.getHours()).padStart(2, '0');
  const minutes = String(zonedDate.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}